import type { OpacityModifierValue } from "schemas/generated/fileModifiers";

import React from "react";

import { useDefaultSelectedElementDesignation } from "@/features/react-editor/components/modifiers/store/ModifiersStoreContext";
import { useOverridableState } from "replo-runtime/shared/hooks/useOverridableState";

import OpacitySelector from "./OpacitySelector";

interface OpacityModifierProps {
  onChange: (modifier: OpacityModifierValue) => void;
}

const OpacityModifier: React.FC<OpacityModifierProps> = ({ onChange }) => {
  const defaultDesignation = useDefaultSelectedElementDesignation();

  const extractedOpacity = React.useMemo(() => {
    const opacity = defaultDesignation?.element.styleOverrides?.opacity ?? 1;
    return Math.round(opacity * 100);
  }, [defaultDesignation]);

  const [currentOpacity, setCurrentOpacity] = useOverridableState(
    extractedOpacity,
    React.useCallback(
      (opacityPercent: number) => {
        if (opacityPercent >= 0 && opacityPercent <= 100) {
          const modifier: OpacityModifierValue = {
            type: "opacity",
            value: opacityPercent / 100,
          };
          onChange(modifier);
        }
      },
      [onChange],
    ),
  );

  return (
    <OpacitySelector opacity={currentOpacity} onSelect={setCurrentOpacity} />
  );
};

export default OpacityModifier;
